import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconEyeStyle0 = gravityIconIndividualCss;

const GravityIconEye = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'ba742d5cfabd58ad71cb7854b81f3e925dbd932a', color: this.color, size: this.size }, h("svg", { key: '6bcaa4d23c0e53eb2b1f7e92abbb9281d4de76e5', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '239bd92ed5b76eee3c5f89e802617f64d15b9c89', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10.991 5c3.554 0 6.471 1.846 8.806 5.285a1.36 1.36 0 0 1 0 1.43l-.013.02C17.54 15.133 14.564 17 10.991 17c-3.57 0-6.523-1.861-8.775-5.27a1.342 1.342 0 0 1 .007-1.471C4.53 6.845 7.438 5 10.991 5Zm0 1.565c-2.943 0-5.37 1.514-7.383 4.436 1.965 2.91 4.426 4.434 7.383 4.434 2.962 0 5.442-1.53 7.403-4.433-2.028-2.925-4.462-4.437-7.403-4.437Zm0 1.565A2.866 2.866 0 0 1 13.854 11a2.866 2.866 0 0 1-2.863 2.87A2.866 2.866 0 0 1 8.128 11a2.866 2.866 0 0 1 2.863-2.87Zm0 1.566c-.719 0-1.301.584-1.301 1.304a1.302 1.302 0 1 0 2.603 0c0-.72-.583-1.304-1.302-1.304Z", fill: "currentColor" }))));
    }
};
GravityIconEye.style = GravityIconEyeStyle0;

export { GravityIconEye as gravity_icon_eye };

//# sourceMappingURL=gravity-icon-eye.entry.js.map